<template>
  <div class="mix-field-wrapper">
    <!-- 范围填写 -->
    <div class="input-number-group" v-if="chooseType === '01'">
      <div style="padding-right: 30px">
        <el-input-number
          :disabled="isDetailPage"
          v-model="min"
          controls-position="right"
          size="small"
          :min="rangeMin"
          :step="isBonusBeer?0.01:1"
          :precision="isBonusBeer?2:0"
          placeholder="最小值"
          @change="
            (currentValue, oldValue) => {
              checkRange(currentValue, oldValue, 'min');
            }
          "
          :max="getEmpty(rangeMax) ? rangeMax : Infinity"
        ></el-input-number>
        <slot></slot>
      </div>
      <div style="padding-right: 30px; font-weight: 600">至</div>
      <div>
        <el-input-number
          :disabled="isDetailPage"
          v-model="max"
          controls-position="right"
          size="small"
          :min="rangeMin"
          :step="isBonusBeer?0.01:1"
          :precision="isBonusBeer?2:0"
          placeholder="最大值"
          @change="
            (currentValue, oldValue) => {
              checkRange(currentValue, oldValue, 'max');
            }
          "
          :max="getEmpty(rangeMax) ? rangeMax : Infinity"
        ></el-input-number>
        <slot></slot>
      </div>
    </div>

    <!-- 固定选项 可填写模式-->
    <div class="input-wrapper" v-if="chooseType === '02' && !isRegion">
      <div class="content" v-for="(item, index) in scope" :key="index">
        <div class="close" v-if="!isDetailPage">
          <i class="el-icon-error" @click="handleDelete(index)"></i>
        </div>
        <div>
          <el-input
            :disabled="isDetailPage"
            placeholder="请填写"
            v-model="scope[index]"
            style="width:80px"
            @blur="checkInput($event, index)"
          ></el-input>
        </div>
      </div>
      <div class="add" v-if="!isDetailPage">
        <i class="el-icon-circle-plus" @click="handleAdd"></i>
      </div>
    </div>

    <!-- 切换模式 -->
    <div
      class="switch-btn"
      v-if="!isDetailPage && this.employeeLevel > 50"
      @click="switchType"
    >
      {{ `切换${chooseType === "01" ? "固定选项" : "范围填写"}模式` }}
    </div>

    <!-- 下级固定选项 使用多选框 -->
    <div class="checkbox-wrapper" v-if="chooseType === '02' && isRegion">
      <div class="checkbox-content">
        <!-- 可选按钮展示 -->
        <div class="checkbox-info">
          <div
            class="checkbox-info-wrapper"
            v-for="(item, index) in checkedInfo"
            :key="index"
          >
            <el-checkbox-button
              :label="item.key || item.skuCode"
              v-model="item.checked"
              :disabled="isDetailPage"
            >
              {{ item.value || item.skuName }}
            </el-checkbox-button>
          </div>
        </div>

        <!-- 是否全选 -->
        <div
          style="width:80px;padding-right:20px"
          class="checkbox-operating"
          v-if="!isDetailPage"
        >
          <el-checkbox-button
            v-model="checkAll"
            @change="handleCheckAllChange"
            >{{ checkAll ? "取消全选" : "全选" }}</el-checkbox-button
          >
        </div>

        <!-- 是否重置 -->
        <div
          style="text-align: right"
          class="checkbox-operating"
          v-if="!isDetailPage"
        >
          <el-button size="mini" type="warning" @click="handleReset"
            >重置</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 选择 或 填写数字范围 组件
  name: 'perfect-theme-mix-field',
  props: {
    // bonusBeer、bonusFee、execWeek
    commonKey: {
      type: String,
      default: ''
    },
    // 用以展示的原始数据
    originInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 用以匹配的数据
    matchInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    employeeLevel: {
      type: Number
    }
  },
  created () {
    this.pageType = this.$route.query.handleType
    this.class = this.$route.query.class
  },
  data () {
    return {
      pageType: null,
      class: '',
      min: 0,
      max: 0,
      rangeMin: 0,
      rangeMax: 0,
      chooseType: '02',

      scope: [''],
      checkAll: null,
      checkedResult: true,
      checkedInfo: []
    }
  },
  computed: {
    isDetailPage () {
      return this.class === 'detail'
    },
    isRegion () {
      return this.employeeLevel <= 50
    },
    isBonusBeer () {
      return this.commonKey === 'bonusBeer'
    }
  },
  watch: {
    checkedInfo: {
      deep: true,
      immediate: true,
      handler (val) {
        // 处理全选逻辑
        this.checkAll = this.checkedInfo.every(item => {
          return item.checked === true
        })
      }
    }
  },
  methods: {
    setData () {
      if (this.pageType === 'config') {
        this.configSetData()
      }
      if (this.pageType === 'update') {
        if (!this.isDetailPage) {
          // 修改页面 根据情况匹配和展示数据
          this.updateSetData()
        } else {
          // 详情页面 用matchInfo展示自身数据
          this.setDataMatch()
          // 如果上级更改配置，导致自身没有数据，应显示为0
          // this.min = this.matchInfo[`${this.commonKey}Min`] || 0
          // this.max = this.matchInfo[`${this.commonKey}Max`] || this.min

          this.min = this.getEmpty(this.matchInfo[`${this.commonKey}Min`]) ? this.matchInfo[`${this.commonKey}Min`] : 0
          this.max = this.getEmpty(this.matchInfo[`${this.commonKey}Max`]) ? this.matchInfo[`${this.commonKey}Max`] : this.min
          if (this.chooseType === '02') {
            let matchScopeArr = this.matchInfo[`${this.commonKey}Scope`] ? this.matchInfo[`${this.commonKey}Scope`].split(',') : []
            this.setCheckedInfo(matchScopeArr, matchScopeArr)
          }
        }
      }
    },

    // 新建配置设置
    configSetData () {
      if (this.isRegion && this.originInfo[`${this.commonKey}ChooseType`] === '02') {
        // 上级为固定选项类型 下级只能在这些选项里选
        this.chooseType = '02'
        let showScopeArr = this.originInfo[`${this.commonKey}Scope`] ? this.originInfo[`${this.commonKey}Scope`].split(',') : ['']
        this.setCheckedInfo(showScopeArr, [])
      } else {
        this.setDataOrigin()
        this.scope = ['']
        // this.chooseType = this.employeeLevel > 50 ? '01' : (this.originInfo[`${this.commonKey}ChooseType`] ? this.originInfo[`${this.commonKey}ChooseType`] : '01')
        this.chooseType = this.employeeLevel > 50 ? '02' : (this.originInfo[`${this.commonKey}ChooseType`] ? this.originInfo[`${this.commonKey}ChooseType`] : '02')
      }
    },

    // 修改配置设置
    updateSetData () {
      let originChoose = this.originInfo[`${this.commonKey}ChooseType`]
      let matchChoose = this.matchInfo[`${this.commonKey}ChooseType`]

      if (this.employeeLevel > 50) {
        // bu
        if (this.originInfo.taskType && !this.matchInfo.taskType) {
          // 任务初始未配置 修改时新增任务的情况  从上级获取值
          this.setDataOrigin()
          this.chooseType = this.originInfo[`${this.commonKey}ChooseType`] ? this.originInfo[`${this.commonKey}ChooseType`] : '02'
          this.scope = this.originInfo[`${this.commonKey}Scope`] ? this.originInfo[`${this.commonKey}Scope`].split(',') : ['']
        } else {
          // 任务已配置过的情况 从自己获取值
          this.setDataMatch()
        }
      } else {
        // region
        if (originChoose === matchChoose) {
          // 上级未更改模式的情况
          this.setDataMatch()

          if (this.chooseType === '02') {
            let showScopeArr = this.originInfo[`${this.commonKey}Scope`] ? this.originInfo[`${this.commonKey}Scope`].split(',') : ['']
            let matchScopeArr = this.matchInfo[`${this.commonKey}Scope`] ? this.matchInfo[`${this.commonKey}Scope`].split(',') : ['']
            this.setCheckedInfo(showScopeArr, matchScopeArr)
          }
        } else {
          // 上级更改模式的情况
          this.setDataOrigin()
          this.chooseType = this.originInfo[`${this.commonKey}ChooseType`] ? this.originInfo[`${this.commonKey}ChooseType`] : '02'
          this.scope = this.originInfo[`${this.commonKey}Scope`] ? this.originInfo[`${this.commonKey}Scope`].split(',') : ['']

          if (this.chooseType === '02') {
            let showScopeArr = this.originInfo[`${this.commonKey}Scope`] ? this.originInfo[`${this.commonKey}Scope`].split(',') : ['']
            this.setCheckedInfo(showScopeArr, [])
          }
        }
      }
    },

    // 从matchInfo获取值的情况:详情展示； bu修改 ；region上级未切换模式的修改
    setDataMatch () {
      let originChoose = this.originInfo[`${this.commonKey}ChooseType`]
      let matchChoose = this.matchInfo[`${this.commonKey}ChooseType`]

      this.chooseType = matchChoose || originChoose || '02'
      // this.min = this.matchInfo[`${this.commonKey}Min`] || this.originInfo[`${this.commonKey}Min`] || 0
      // this.max = this.matchInfo[`${this.commonKey}Max`] || this.originInfo[`${this.commonKey}Max`] || this.min

      if (this.getEmpty(this.matchInfo[`${this.commonKey}Min`])) {
        this.min = this.matchInfo[`${this.commonKey}Min`]
      } else if (this.getEmpty(this.originInfo[`${this.commonKey}Min`])) {
        this.min = this.originInfo[`${this.commonKey}Min`]
      } else {
        this.min = 0
      }

      if (this.getEmpty(this.matchInfo[`${this.commonKey}Max`])) {
        this.max = this.matchInfo[`${this.commonKey}Max`]
      } else if (this.getEmpty(this.originInfo[`${this.commonKey}Max`])) {
        this.max = this.originInfo[`${this.commonKey}Max`]
      } else {
        this.max = this.min
      }

      this.rangeMin = this.getEmpty(this.originInfo[`${this.commonKey}Min`]) ? this.originInfo[`${this.commonKey}Min`] : 0
      this.rangeMax = this.getEmpty(this.originInfo[`${this.commonKey}Max`]) ? this.originInfo[`${this.commonKey}Max`] : Infinity
      this.scope = this.matchInfo[`${this.commonKey}Scope`] ? this.matchInfo[`${this.commonKey}Scope`].split(',') : ['']
    },

    // 从originInfo获取值的情况：一般情况下的新建；region上级更改模式;bu修改增加未配置的任务时 （无配置chooseType和scope）
    setDataOrigin () {
      this.min = this.getEmpty(this.originInfo[`${this.commonKey}Min`]) ? this.originInfo[`${this.commonKey}Min`] : 0
      this.max = this.getEmpty(this.originInfo[`${this.commonKey}Max`]) ? this.originInfo[`${this.commonKey}Max`] : this.min
      this.rangeMin = this.getEmpty(this.originInfo[`${this.commonKey}Min`]) ? this.originInfo[`${this.commonKey}Min`] : 0
      this.rangeMax = this.getEmpty(this.originInfo[`${this.commonKey}Max`]) ? this.originInfo[`${this.commonKey}Max`] : Infinity
    },

    // 配置checkedInfo region相关choosetype==='02'时
    setCheckedInfo (showScopeArr, matchScopeArr) {
      let arr = []
      if (showScopeArr.length) {
        showScopeArr.forEach(item => {
          arr.push({
            key: item,
            value: item,
            checked: matchScopeArr.includes(item)
          })
        })
      }
      this.checkedInfo = arr
    },

    getEmpty (value) {
      return value !== undefined && value !== null
    },

    // 切换模式
    switchType () {
      if (this.chooseType === '01') {
        this.chooseType = '02'
      } else if (this.chooseType === '02') {
        this.chooseType = '01'
      }
    },

    // 删除
    handleDelete (index) {
      if (this.scope.length <= 1) return
      this.scope.splice(index, 1)
    },
    // 新增
    handleAdd () {
      this.scope.push('')
    },
    // 范围填写的填写校验
    checkRange (newValue, oldValue, rangeType) {
      // if (!newValue) {
      if (!this.getEmpty(newValue)) {
        this.$nextTick(() => {
          if (rangeType === 'min') {
            this.min = oldValue
          } else {
            this.max = oldValue
          }
        })
      } else {
        if (this.min > this.max || this.max < this.min) {
          this.$nextTick(() => {
            let num = this.min
            this.min = this.max
            this.max = num
          })
          this.$message.warning('请规范填写大小范围')
        }
      }
    },
    // 固定选项的填写校验
    checkInput (e, index) {
      let v = e.target.value
      let conditionFlag = this.isBonusBeer ? Boolean(v && !/^([0-9]\d*)(\s|$|\.\d{1,2}\b)/.test(v)) : Boolean(v && !/^[0-9]\d*$/.test(v))
      let hint = this.isBonusBeer ? '请输入大于等于零且最多包含两位小数的数字' : '请输入大于等于零的整数'
      if (conditionFlag) {
        this.$message.warning(hint)
        e.target.value = ''
        this.scope[index] = ''
        return
      }

      if (v) {
        this.scope[index] = ''
        // let value = v.replace(/[^\d]/g, '')
        let value = this.isBonusBeer ? (Math.round(v * 100) / 100).toString() : (v.replace(/[^\d]/g, ''))

        if (value > this.rangeMax || value < this.rangeMin) {
          this.$message.warning('超过可填写范围')
        } else if (this.scope.indexOf(value) !== -1) {
          this.$message.warning('已存在相同数据')
        } else {
          this.scope[index] = value
          e.target.value = value
        }
      }
    },

    // 补全小数
    // handleDec (value) {
    //   let floatV = parseFloat(value)
    //   if (isNaN(floatV)) {
    //     return 0
    //   }
    //   floatV = Math.round(value * 100) / 100
    //   let strV = floatV.toString()
    //   let decIndex = strV.indexOf('.')
    //   if (decIndex < 0) {
    //     decIndex = strV.length
    //     strV += '.'
    //   }
    //   while (strV.length <= decIndex + 2) {
    //     strV += '0'
    //   }
    //   return strV
    // },

    // 全选
    handleCheckAllChange (val) {
      if (this.checkedInfo.length) {
        this.checkedInfo.forEach(item => {
          item.checked = val
        })
      }
    },
    // 重置
    handleReset () {
      this.setData()
    },
    // 获取checkbox对应范围
    getScope () {
      let arr = []
      if (this.checkedInfo.length) {
        this.checkedInfo.forEach(item => {
          if (item.checked) {
            arr.push(item.value)
          }
        })
      }

      return arr
    },

    // 主组件时检查数据
    checkData () {
      this.checkedResult = true
      // region 为固定选项 用checked校验
      if (this.isRegion && this.chooseType === '02') {
        let checkedResult = false
        if (this.checkedInfo.length) {
          this.checkedInfo.forEach(item => {
            if (item.checked) checkedResult = true
          })
        }
        this.checkedResult = checkedResult
      } else if (this.chooseType === '02') {
        // 02 用scope是否为空校验 有一个及以上的数据即可
        let checkedResult = false
        if (this.scope.length) {
          checkedResult = this.scope.some(item => {
            return Boolean(item)
          })
        }
        this.checkedResult = checkedResult
      } else if (this.chooseType === '01') {
        // 01 用min max是否为空校验
        if (this.max && this.min) {
          this.checkedResult = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mix-field-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-number-group {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  width: 500px;
}
.input-wrapper {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  width: 500px;
  .content {
    position: relative;
    margin-right: 25px;
    .close {
      z-index: 99;
      position: absolute;
      right: -7px;
      color: rgb(234, 84, 4);
      height: 20px;
      line-height: 20px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .add {
    color: #56b0ff;
    font-size: 20px;
    cursor: pointer;
  }
}
.switch-btn {
  flex-basis: 30%;
  width: 150px;
  height: 20px;
  line-height: 20px;
  margin-left: 30px;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  color: #56b0ff;
  background-color: #eef6fd;
  border: 1px dashed #56b0ff;
  cursor: pointer;
  flex: 0 1 auto;
  flex: 0 0 auto;
  box-sizing: content-box;
}

.checkbox-wrapper {
  width: 100%;
  padding: 10px 0;
  background-color: #fff;
  .checkbox-info-wrapper {
    display: inline-block;
    position: relative;
    .delete-btn {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 5px;
      top: -5px;
      color: #c8102d;
      font-size: 12px;
      line-height: 20px;
      cursor: pointer;
      z-index: 999;
      text-align: center;
    }
  }
  .checkbox-content {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    color: #333;
    transition: height 0.5s;
    .checkbox-info {
      flex-basis: 80%;
    }
    .add {
      display: inline-block;
      color: #56b0ff;
      font-size: 20px;
      cursor: pointer;
    }
    .checkbox-operating {
      flex: none;
      flex-basis: 8%;
      margin: auto;
    }
  }
}
</style>
